"use client";

import { c as _c } from "react/compiler-runtime";
import { Close, Tune } from "@mui/icons-material";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import React, { useState } from "react";
import { Button, ButtonVariant, Filtering, Pricing, Sorting, Text, TextSize, TextWeight } from "../../components";
const DISABLED_MORE_FILTERS_BUTTON = true;
export const SortingFiltering = t0 => {
  const $ = _c(165);
  const {
    sortOptions,
    filterColorOptions,
    filterSizeOptions,
    minPrice,
    maxPrice,
    showOnSaleOnly,
    setShowOnSaleOnly,
    selectedMinPrice,
    selectedMaxPrice,
    setSelectedMinPrice,
    setSelectedMaxPrice,
    selectedOption,
    setSelectedOption,
    selectedColorOptions,
    selectedSizeOptions,
    setSelectedColorOptions,
    setSelectedSizeOptions,
    appliedColorOptions,
    appliedSizeOptions,
    appliedMinPrice,
    appliedMaxPrice,
    appliedOnSaleOnly,
    onApplyFilters,
    filterFeatureOptions,
    setSelectedFeatureOptions,
    selectedFeatureOptions,
    appliedFeatureOptions
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  if ($[0] !== onApplyFilters) {
    t1 = (colors, sizes, features, minPrice_0, maxPrice_0, onSaleOnly) => {
      onApplyFilters(colors, sizes, features, minPrice_0, maxPrice_0, onSaleOnly);
    };
    $[0] = onApplyFilters;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleApplyFilters = t1;
  let t2;
  if ($[2] !== onApplyFilters || $[3] !== setSelectedColorOptions || $[4] !== setSelectedFeatureOptions || $[5] !== setSelectedMaxPrice || $[6] !== setSelectedMinPrice || $[7] !== setSelectedSizeOptions || $[8] !== setShowOnSaleOnly) {
    t2 = () => {
      setSelectedColorOptions([]);
      setSelectedSizeOptions([]);
      setSelectedFeatureOptions([]);
      setShowOnSaleOnly(false);
      setSelectedMinPrice(null);
      setSelectedMaxPrice(null);
      onApplyFilters([], [], [], null, null, false);
    };
    $[2] = onApplyFilters;
    $[3] = setSelectedColorOptions;
    $[4] = setSelectedFeatureOptions;
    $[5] = setSelectedMaxPrice;
    $[6] = setSelectedMinPrice;
    $[7] = setSelectedSizeOptions;
    $[8] = setShowOnSaleOnly;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const handleClearAllFilters = t2;
  let t3;
  if ($[10] !== selectedOption || $[11] !== setSelectedOption || $[12] !== sortOptions) {
    t3 = <Sorting selectedOption={selectedOption} setSelectedOption={setSelectedOption} sortOptions={sortOptions} onSort={_temp} />;
    $[10] = selectedOption;
    $[11] = setSelectedOption;
    $[12] = sortOptions;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== filterSizeOptions || $[15] !== handleApplyFilters || $[16] !== selectedColorOptions || $[17] !== selectedFeatureOptions || $[18] !== selectedMaxPrice || $[19] !== selectedMinPrice || $[20] !== selectedSizeOptions || $[21] !== setSelectedSizeOptions || $[22] !== showOnSaleOnly) {
    t4 = <Filtering filterLabel="Rozmiar" filterOptions={filterSizeOptions} selectedOptions={selectedSizeOptions} setSelectedOptions={setSelectedSizeOptions} onApplyFilters={handleApplyFilters} allSelectedColors={selectedColorOptions} allSelectedSizes={selectedSizeOptions} currentMinPrice={selectedMinPrice} currentMaxPrice={selectedMaxPrice} currentOnSaleOnly={showOnSaleOnly} currentFeatures={selectedFeatureOptions} filterType="size" />;
    $[14] = filterSizeOptions;
    $[15] = handleApplyFilters;
    $[16] = selectedColorOptions;
    $[17] = selectedFeatureOptions;
    $[18] = selectedMaxPrice;
    $[19] = selectedMinPrice;
    $[20] = selectedSizeOptions;
    $[21] = setSelectedSizeOptions;
    $[22] = showOnSaleOnly;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  let t5;
  if ($[24] !== filterColorOptions || $[25] !== handleApplyFilters || $[26] !== selectedColorOptions || $[27] !== selectedFeatureOptions || $[28] !== selectedMaxPrice || $[29] !== selectedMinPrice || $[30] !== selectedSizeOptions || $[31] !== setSelectedColorOptions || $[32] !== showOnSaleOnly) {
    t5 = <Filtering filterLabel="Kolor" filterOptions={filterColorOptions} selectedOptions={selectedColorOptions} setSelectedOptions={setSelectedColorOptions} onApplyFilters={handleApplyFilters} allSelectedColors={selectedColorOptions} allSelectedSizes={selectedSizeOptions} currentMinPrice={selectedMinPrice} currentMaxPrice={selectedMaxPrice} currentOnSaleOnly={showOnSaleOnly} currentFeatures={selectedFeatureOptions} filterType="color" />;
    $[24] = filterColorOptions;
    $[25] = handleApplyFilters;
    $[26] = selectedColorOptions;
    $[27] = selectedFeatureOptions;
    $[28] = selectedMaxPrice;
    $[29] = selectedMinPrice;
    $[30] = selectedSizeOptions;
    $[31] = setSelectedColorOptions;
    $[32] = showOnSaleOnly;
    $[33] = t5;
  } else {
    t5 = $[33];
  }
  let t6;
  if ($[34] !== handleApplyFilters || $[35] !== maxPrice || $[36] !== minPrice || $[37] !== selectedColorOptions || $[38] !== selectedFeatureOptions || $[39] !== selectedMaxPrice || $[40] !== selectedMinPrice || $[41] !== selectedSizeOptions || $[42] !== setSelectedMaxPrice || $[43] !== setSelectedMinPrice || $[44] !== setShowOnSaleOnly || $[45] !== showOnSaleOnly) {
    t6 = <Pricing priceLabel="Cena" minPrice={minPrice} maxPrice={maxPrice} currency="PLN" showOnSaleOnly={showOnSaleOnly} setShowOnSaleOnly={setShowOnSaleOnly} selectedMinPrice={selectedMinPrice} selectedMaxPrice={selectedMaxPrice} setSelectedMinPrice={setSelectedMinPrice} setSelectedMaxPrice={setSelectedMaxPrice} onApplyFilters={handleApplyFilters} allSelectedColors={selectedColorOptions} allSelectedSizes={selectedSizeOptions} currentFeatures={selectedFeatureOptions} />;
    $[34] = handleApplyFilters;
    $[35] = maxPrice;
    $[36] = minPrice;
    $[37] = selectedColorOptions;
    $[38] = selectedFeatureOptions;
    $[39] = selectedMaxPrice;
    $[40] = selectedMinPrice;
    $[41] = selectedSizeOptions;
    $[42] = setSelectedMaxPrice;
    $[43] = setSelectedMinPrice;
    $[44] = setShowOnSaleOnly;
    $[45] = showOnSaleOnly;
    $[46] = t6;
  } else {
    t6 = $[46];
  }
  let t7;
  if ($[47] !== filterFeatureOptions || $[48] !== handleApplyFilters || $[49] !== maxPrice || $[50] !== minPrice || $[51] !== selectedColorOptions || $[52] !== selectedFeatureOptions || $[53] !== selectedMaxPrice || $[54] !== selectedMinPrice || $[55] !== selectedSizeOptions || $[56] !== setSelectedFeatureOptions || $[57] !== showOnSaleOnly) {
    t7 = filterFeatureOptions && filterFeatureOptions.length > 0 && filterFeatureOptions.map(option => {
      const selectedForThisFeature = selectedFeatureOptions.filter(feature => option.values.some(val => val.id === feature.id));
      return <Filtering key={option.idFeature} filterLabel={option.name} filterOptions={option.values} selectedOptions={selectedForThisFeature} setSelectedOptions={newOptions => {
        const otherFeatures = selectedFeatureOptions.filter(feature_0 => !option.values.some(val_0 => val_0.id === feature_0.id));
        const updatedFeatures = Array.isArray(newOptions) ? [...otherFeatures, ...newOptions] : [...otherFeatures, ...newOptions(selectedForThisFeature)];
        setSelectedFeatureOptions(updatedFeatures);
        setTimeout(() => {
          handleApplyFilters(selectedColorOptions, selectedSizeOptions, updatedFeatures, selectedMinPrice || minPrice, selectedMaxPrice || maxPrice, showOnSaleOnly);
        }, 0);
      }} onApplyFilters={handleApplyFilters} allSelectedColors={selectedColorOptions} allSelectedSizes={selectedSizeOptions} currentMinPrice={selectedMinPrice} currentMaxPrice={selectedMaxPrice} currentOnSaleOnly={showOnSaleOnly} currentFeatures={selectedFeatureOptions} filterType={`feature-${option.idFeature}`} />;
    });
    $[47] = filterFeatureOptions;
    $[48] = handleApplyFilters;
    $[49] = maxPrice;
    $[50] = minPrice;
    $[51] = selectedColorOptions;
    $[52] = selectedFeatureOptions;
    $[53] = selectedMaxPrice;
    $[54] = selectedMinPrice;
    $[55] = selectedSizeOptions;
    $[56] = setSelectedFeatureOptions;
    $[57] = showOnSaleOnly;
    $[58] = t7;
  } else {
    t7 = $[58];
  }
  let t8;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = !DISABLED_MORE_FILTERS_BUTTON && <div className="flex items-center gap-2 cursor-pointer" onClick={() => setIsOpen(true)}><Tune className="!w-4 !h-4 text-gray-600" /><Text text={"Wi\u0119cej filtr\xF3w"} fontSize={TextSize.XS} textTransform="uppercase" className="tracking-widest" /></div>;
    $[59] = t8;
  } else {
    t8 = $[59];
  }
  let t9;
  if ($[60] !== t3 || $[61] !== t4 || $[62] !== t5 || $[63] !== t6 || $[64] !== t7) {
    t9 = <div className="flex items-center gap-8">{t3}{t4}{t5}{t6}{t7}{t8}</div>;
    $[60] = t3;
    $[61] = t4;
    $[62] = t5;
    $[63] = t6;
    $[64] = t7;
    $[65] = t9;
  } else {
    t9 = $[65];
  }
  let t10;
  if ($[66] !== appliedColorOptions || $[67] !== appliedFeatureOptions || $[68] !== appliedMaxPrice || $[69] !== appliedMinPrice || $[70] !== appliedOnSaleOnly || $[71] !== appliedSizeOptions || $[72] !== handleApplyFilters || $[73] !== setSelectedColorOptions) {
    t10 = appliedColorOptions && appliedColorOptions.length > 0 && appliedColorOptions.map(option_0 => <div key={option_0.id} className="border border-gray-400 px-2 py-1.5 flex items-center gap-2"><div className="w-4 h-4 border border-gray-300" style={{
        backgroundColor: option_0.color
      }} /><Text text={option_0.label} fontSize={TextSize.XS} /><Close className="cursor-pointer text-gray-400 !w-4 !h-4" onClick={() => {
        const newColors = appliedColorOptions.filter(o => o.id !== option_0.id);
        setSelectedColorOptions(newColors);
        handleApplyFilters(newColors, appliedSizeOptions, appliedFeatureOptions, appliedMinPrice, appliedMaxPrice, appliedOnSaleOnly);
      }} /></div>);
    $[66] = appliedColorOptions;
    $[67] = appliedFeatureOptions;
    $[68] = appliedMaxPrice;
    $[69] = appliedMinPrice;
    $[70] = appliedOnSaleOnly;
    $[71] = appliedSizeOptions;
    $[72] = handleApplyFilters;
    $[73] = setSelectedColorOptions;
    $[74] = t10;
  } else {
    t10 = $[74];
  }
  let t11;
  if ($[75] !== appliedColorOptions || $[76] !== appliedFeatureOptions || $[77] !== appliedMaxPrice || $[78] !== appliedMinPrice || $[79] !== appliedOnSaleOnly || $[80] !== appliedSizeOptions || $[81] !== handleApplyFilters || $[82] !== setSelectedSizeOptions) {
    t11 = appliedSizeOptions && appliedSizeOptions.length > 0 && appliedSizeOptions.map(option_1 => <div key={option_1.id} className="border border-gray-400 px-2 py-1.5 flex items-center gap-2"><Text text={option_1.label} fontSize={TextSize.XS} /><Close className="cursor-pointer text-gray-400 !w-4 !h-4" onClick={() => {
        const newSizes = appliedSizeOptions.filter(o_0 => o_0.id !== option_1.id);
        setSelectedSizeOptions(newSizes);
        handleApplyFilters(appliedColorOptions, newSizes, appliedFeatureOptions, appliedMinPrice, appliedMaxPrice, appliedOnSaleOnly);
      }} /></div>);
    $[75] = appliedColorOptions;
    $[76] = appliedFeatureOptions;
    $[77] = appliedMaxPrice;
    $[78] = appliedMinPrice;
    $[79] = appliedOnSaleOnly;
    $[80] = appliedSizeOptions;
    $[81] = handleApplyFilters;
    $[82] = setSelectedSizeOptions;
    $[83] = t11;
  } else {
    t11 = $[83];
  }
  let t12;
  if ($[84] !== appliedColorOptions || $[85] !== appliedFeatureOptions || $[86] !== appliedMaxPrice || $[87] !== appliedMinPrice || $[88] !== appliedOnSaleOnly || $[89] !== appliedSizeOptions || $[90] !== handleApplyFilters || $[91] !== setSelectedFeatureOptions) {
    t12 = appliedFeatureOptions && appliedFeatureOptions.length > 0 && appliedFeatureOptions.map(option_2 => <div key={option_2.id} className="border border-gray-400 px-2 py-1.5 flex items-center gap-2"><Text text={option_2.label} fontSize={TextSize.XS} /><Close className="cursor-pointer text-gray-400 !w-4 !h-4" onClick={() => {
        const newFeatures = appliedFeatureOptions.filter(o_1 => o_1.id !== option_2.id);
        setSelectedFeatureOptions(newFeatures);
        handleApplyFilters(appliedColorOptions, appliedSizeOptions, newFeatures, appliedMinPrice, appliedMaxPrice, appliedOnSaleOnly);
      }} /></div>);
    $[84] = appliedColorOptions;
    $[85] = appliedFeatureOptions;
    $[86] = appliedMaxPrice;
    $[87] = appliedMinPrice;
    $[88] = appliedOnSaleOnly;
    $[89] = appliedSizeOptions;
    $[90] = handleApplyFilters;
    $[91] = setSelectedFeatureOptions;
    $[92] = t12;
  } else {
    t12 = $[92];
  }
  let t13;
  if ($[93] !== appliedColorOptions || $[94] !== appliedFeatureOptions || $[95] !== appliedMaxPrice || $[96] !== appliedMinPrice || $[97] !== appliedOnSaleOnly || $[98] !== appliedSizeOptions || $[99] !== handleApplyFilters || $[100] !== minPrice || $[101] !== setSelectedMinPrice) {
    t13 = minPrice !== appliedMinPrice && appliedMinPrice !== 0 && <div className="border border-gray-400 px-2 py-1.5 flex items-center gap-2"><Text text={`Cena od ${appliedMinPrice} zł`} fontSize={TextSize.XS} /><Close className="cursor-pointer text-gray-400 !w-4 !h-4" onClick={() => {
        setSelectedMinPrice(null);
        handleApplyFilters(appliedColorOptions, appliedSizeOptions, appliedFeatureOptions, null, appliedMaxPrice, appliedOnSaleOnly);
      }} /></div>;
    $[93] = appliedColorOptions;
    $[94] = appliedFeatureOptions;
    $[95] = appliedMaxPrice;
    $[96] = appliedMinPrice;
    $[97] = appliedOnSaleOnly;
    $[98] = appliedSizeOptions;
    $[99] = handleApplyFilters;
    $[100] = minPrice;
    $[101] = setSelectedMinPrice;
    $[102] = t13;
  } else {
    t13 = $[102];
  }
  let t14;
  if ($[103] !== appliedColorOptions || $[104] !== appliedFeatureOptions || $[105] !== appliedMaxPrice || $[106] !== appliedMinPrice || $[107] !== appliedOnSaleOnly || $[108] !== appliedSizeOptions || $[109] !== handleApplyFilters || $[110] !== maxPrice || $[111] !== setSelectedMaxPrice) {
    t14 = maxPrice !== appliedMaxPrice && appliedMaxPrice !== 0 && <div className="border border-gray-400 px-2 py-1.5 flex items-center gap-2"><Text text={`Cena do ${appliedMaxPrice} zł`} fontSize={TextSize.XS} /><Close className="cursor-pointer text-gray-400 !w-4 !h-4" onClick={() => {
        setSelectedMaxPrice(null);
        handleApplyFilters(appliedColorOptions, appliedSizeOptions, appliedFeatureOptions, appliedMinPrice, null, appliedOnSaleOnly);
      }} /></div>;
    $[103] = appliedColorOptions;
    $[104] = appliedFeatureOptions;
    $[105] = appliedMaxPrice;
    $[106] = appliedMinPrice;
    $[107] = appliedOnSaleOnly;
    $[108] = appliedSizeOptions;
    $[109] = handleApplyFilters;
    $[110] = maxPrice;
    $[111] = setSelectedMaxPrice;
    $[112] = t14;
  } else {
    t14 = $[112];
  }
  let t15;
  if ($[113] !== appliedColorOptions || $[114] !== appliedFeatureOptions || $[115] !== appliedMaxPrice || $[116] !== appliedMinPrice || $[117] !== appliedOnSaleOnly || $[118] !== appliedSizeOptions || $[119] !== handleApplyFilters || $[120] !== setShowOnSaleOnly) {
    t15 = appliedOnSaleOnly && <div className="border border-gray-400 px-2 py-1.5 flex items-center gap-2"><Text text="Tylko promocje" fontSize={TextSize.XS} /><Close className="cursor-pointer text-gray-400 !w-4 !h-4" onClick={() => {
        setShowOnSaleOnly(false);
        handleApplyFilters(appliedColorOptions, appliedSizeOptions, appliedFeatureOptions, appliedMinPrice, appliedMaxPrice, false);
      }} /></div>;
    $[113] = appliedColorOptions;
    $[114] = appliedFeatureOptions;
    $[115] = appliedMaxPrice;
    $[116] = appliedMinPrice;
    $[117] = appliedOnSaleOnly;
    $[118] = appliedSizeOptions;
    $[119] = handleApplyFilters;
    $[120] = setShowOnSaleOnly;
    $[121] = t15;
  } else {
    t15 = $[121];
  }
  let t16;
  if ($[122] !== appliedColorOptions || $[123] !== appliedFeatureOptions || $[124] !== appliedMaxPrice || $[125] !== appliedMinPrice || $[126] !== appliedOnSaleOnly || $[127] !== appliedSizeOptions || $[128] !== handleClearAllFilters || $[129] !== maxPrice || $[130] !== minPrice) {
    t16 = (appliedColorOptions && appliedColorOptions.length > 0 || appliedSizeOptions && appliedSizeOptions.length > 0 || appliedFeatureOptions && appliedFeatureOptions.length > 0 || appliedOnSaleOnly || minPrice !== appliedMinPrice && appliedMinPrice !== 0 || maxPrice !== appliedMaxPrice && appliedMaxPrice !== 0) && <div className="mx-2 cursor-pointer" onClick={handleClearAllFilters}><Text text={"Wyczy\u015B\u0107 wszystkie filtry"} fontSize={TextSize.XS} textDecoration="underline" weight={TextWeight.SEMIBOLD} /></div>;
    $[122] = appliedColorOptions;
    $[123] = appliedFeatureOptions;
    $[124] = appliedMaxPrice;
    $[125] = appliedMinPrice;
    $[126] = appliedOnSaleOnly;
    $[127] = appliedSizeOptions;
    $[128] = handleClearAllFilters;
    $[129] = maxPrice;
    $[130] = minPrice;
    $[131] = t16;
  } else {
    t16 = $[131];
  }
  let t17;
  if ($[132] !== t10 || $[133] !== t11 || $[134] !== t12 || $[135] !== t13 || $[136] !== t14 || $[137] !== t15 || $[138] !== t16) {
    t17 = <div className="flex items-center gap-2 mt-4">{t10}{t11}{t12}{t13}{t14}{t15}{t16}</div>;
    $[132] = t10;
    $[133] = t11;
    $[134] = t12;
    $[135] = t13;
    $[136] = t14;
    $[137] = t15;
    $[138] = t16;
    $[139] = t17;
  } else {
    t17 = $[139];
  }
  let t18;
  let t19;
  if ($[140] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = () => setIsOpen(false);
    t19 = () => setIsOpen(true);
    $[140] = t18;
    $[141] = t19;
  } else {
    t18 = $[140];
    t19 = $[141];
  }
  let t20;
  if ($[142] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Text text="Sortowanie i filtry" fontSize={TextSize.XL} weight={TextWeight.SEMIBOLD} />;
    $[142] = t20;
  } else {
    t20 = $[142];
  }
  let t21;
  if ($[143] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div className="flex items-center justify-between p-4 border-b border-gray-200">{t20}<Close className="cursor-pointer text-gray-400 !w-4 !h-4" onClick={() => setIsOpen(false)} /></div>;
    $[143] = t21;
  } else {
    t21 = $[143];
  }
  let t22;
  if ($[144] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <div className="p-4 flex-1 overflow-y-auto"><Text text={"Wi\u0119cej filtr\xF3w"} fontSize={TextSize.XS} /></div>;
    $[144] = t22;
  } else {
    t22 = $[144];
  }
  let t23;
  if ($[145] !== handleClearAllFilters) {
    t23 = <Button text={"Wyczy\u015B\u0107"} fullWidth={true} className="!w-full" variant={ButtonVariant.SECONDARY} onClick={handleClearAllFilters} />;
    $[145] = handleClearAllFilters;
    $[146] = t23;
  } else {
    t23 = $[146];
  }
  let t24;
  if ($[147] !== handleApplyFilters || $[148] !== selectedColorOptions || $[149] !== selectedFeatureOptions || $[150] !== selectedMaxPrice || $[151] !== selectedMinPrice || $[152] !== selectedSizeOptions || $[153] !== showOnSaleOnly) {
    t24 = <Button text="Zastosuj" fullWidth={true} className="!w-full" onClick={() => {
      handleApplyFilters(selectedColorOptions, selectedSizeOptions, selectedFeatureOptions, selectedMinPrice, selectedMaxPrice, showOnSaleOnly);
      setIsOpen(false);
    }} />;
    $[147] = handleApplyFilters;
    $[148] = selectedColorOptions;
    $[149] = selectedFeatureOptions;
    $[150] = selectedMaxPrice;
    $[151] = selectedMinPrice;
    $[152] = selectedSizeOptions;
    $[153] = showOnSaleOnly;
    $[154] = t24;
  } else {
    t24 = $[154];
  }
  let t25;
  if ($[155] !== t23 || $[156] !== t24) {
    t25 = <div className="min-w-[480px] h-full bg-white flex flex-col">{t21}{t22}<div className="flex gap-2 p-4 w-full border-t border-gray-200 flex-shrink-0 bg-white">{t23}{t24}</div></div>;
    $[155] = t23;
    $[156] = t24;
    $[157] = t25;
  } else {
    t25 = $[157];
  }
  let t26;
  if ($[158] !== isOpen || $[159] !== t25) {
    t26 = <SwipeableDrawer anchor="right" open={isOpen} onClose={t18} onOpen={t19}>{t25}</SwipeableDrawer>;
    $[158] = isOpen;
    $[159] = t25;
    $[160] = t26;
  } else {
    t26 = $[160];
  }
  let t27;
  if ($[161] !== t17 || $[162] !== t26 || $[163] !== t9) {
    t27 = <div className="w-full max-w-screen-2xl mx-auto ">{t9}{t17}{t26}</div>;
    $[161] = t17;
    $[162] = t26;
    $[163] = t9;
    $[164] = t27;
  } else {
    t27 = $[164];
  }
  return t27;
};
export default SortingFiltering;
function _temp() {}